//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableauUserAccessService from '@/apps/data-platform/services/visualization/tableauRol';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
export default {
  name: 'UserAccessDetails',
  components: {
    DialogConfirmationComponent: DialogConfirmationComponent
  },
  props: {
    record: {
      type: Object,
      require: true,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      items: []
    };
  },
  watch: {
    record: function record(var1) {
      this.getItems();
    }
  },
  created: function created() {
    this.getItems();
  },
  mounted: function mounted() {
    var _this = this;
    this.$bus.$on('onReloadDetail', function () {
      _this.getItems();
    });
  },
  computed: {
    fields: function fields() {
      return [{
        value: 'user_dp',
        text: this.traductor('tablas.user_inca'),
        class: 'w-30',
        sortable: true
      }, {
        value: 'applicant_user',
        text: this.traductor('tablas.applicant'),
        class: 'text-center w-30',
        sortable: true
      }, {
        value: 'creation_date',
        text: this.traductor('tablas.creation_time'),
        class: 'text-center w-20',
        sortable: true
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions'),
        class: 'text-center w-20'
      }];
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onClickActivate: function onClickActivate(item) {
      var _this2 = this;
      var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var params = {
        record: {
          document_id: "".concat(item.user_dp, "_").concat(item.document_id),
          active: active
        }
      };
      TableauUserAccessService.updateTableauUserDP(params).then(function (response) {
        _this2.$set(item, 'active', active);
      });
    },
    onClickDelete: function onClickDelete(_index) {
      console.log("borrando");
      for (var index in this.items) {
        if (_index !== index) {
          this.$root.$emit('bv::hide::popover', "popover-button-sync-".concat(this.record.id).concat(index));
        }
      }
    },
    onDeleteClose: function onDeleteClose(index) {
      this.$root.$emit('bv::hide::popover', "popover-button-sync-".concat(this.record.id).concat(index));
    },
    onDeleteAccept: function onDeleteAccept(item, _index) {
      var _this3 = this;
      var params = {
        record: {
          document_id: "".concat(item.user_dp, "_").concat(item.document_id)
        }
      };
      TableauUserAccessService.deleteTableauUserDP(params).then(function (response) {
        if (response.data.success) {
          _this3.$root.$emit('bv::hide::popover', "popover-button-sync-".concat(_this3.record.id).concat(_index));
          _this3.items = _this3.items.filter(function (record, index) {
            return index !== _index;
          });
        }
      });
    },
    rowClass: function rowClass(item, type) {
      if (!item || type !== 'row') return;
      if (item.active) return 'table-success';
      if (!item.active) return 'table-danger';
    },
    getItems: function getItems() {
      var _this4 = this;
      var params = {
        record: {
          document_id: this.record.name
        }
      };
      TableauUserAccessService.getTableauUserDP(params).then(function (response) {
        _this4.items = response.data.result;
      });
    }
  }
};